import { motion } from "framer-motion";
import WaitlistForm from "./WaitlistForm";

export default function Waitlist() {
  return (
    <section
      id="waitlist"
      data-testid="waitlist-section"
      className="py-16 md:py-36 bg-[#0a0a0a] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-12">
        <div className="lg:col-span-5">
          <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-6">
            Future Programs & Membership
          </p>
          <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl md:text-7xl">
            Join The Waitlist
          </h2>
          <p className="mt-6 text-white/60 text-base md:text-lg max-w-md">
            Be first to know when new programs, membership tiers, camps, and
            merchandise drop. No commitment — just early access.
          </p>
          <p className="mt-4 text-white/45 text-sm max-w-md">
            Looking to start now? A free evaluation is the fastest way in.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7 bg-[#0b0b0b] border border-white/10 p-6 md:p-12"
        >
          <WaitlistForm source="waitlist" />
        </motion.div>
      </div>
    </section>
  );
}
